import styled from 'styled-components';

export const AccordionsColumn = styled.div<{
  $espacamentoEntreAccordions: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
}>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme, $espacamentoEntreAccordions }) =>
    theme.spacing[$espacamentoEntreAccordions]}px;
`;
